(() => {
  if (customElements.get('tbc-discovery-quiz')) return;
  const cache = new Map();
  function loadProduct(handle) {
    if (!cache.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      cache.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}.js`, { signal: AbortSignal.timeout(12000) })
        .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .catch(error => { cache.delete(handle); throw error; }));
    }
    return cache.get(handle);
  }
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function photo(product) {
    if (!product.featured_image) return null;
    const image = element('img');
    const url = new URL(product.featured_image, window.location.origin);
    url.searchParams.set('width', '600');
    image.src = url.href;
    image.alt = '';
    image.width = 600;
    image.height = 600;
    image.loading = 'eager';
    image.decoding = 'async';
    image.addEventListener('error', () => image.remove(), { once: true });
    return image;
  }
  function previewUrl(path) {
    const url = new URL(path, window.location.origin);
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id') || (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : null);
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search + url.hash;
  }

  class DiscoveryQuiz extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('[data-quiz-body]');
      this.heading = this.querySelector('[data-quiz-title]');
      this.intro = this.querySelector('[data-quiz-intro]');
      this.status = this.querySelector('[data-quiz-status]');
      this.back = this.querySelector('[data-quiz-back]');
      this.token = 0;
      this.history = [];
      this.querySelector('[data-quiz-open]').addEventListener('click', () => this.open());
      this.querySelector('[data-quiz-close]').addEventListener('click', () => this.close());
      this.back.addEventListener('click', () => this.goBack());
      this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.restore(); });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); });
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')]
          .filter(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
        const first = controls[0];
        const last = controls.at(-1);
        if (!first) { event.preventDefault(); this.heading.focus(); return; }
        if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      });
    }
    disconnectedCallback() { if (this.dialog?.open) this.close(); }
    open() {
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.sessionActive = true;
      document.body.classList.add('tbcq-open');
      this.history = [];
      this.querySelectorAll('[data-quiz-contact]').forEach(link => { link.href = previewUrl(link.getAttribute('href')); });
      this.dialog.showModal();
      this.render();
    }
    close() { this.dialog.close(); this.restore(); }
    restore() {
      if (!this.sessionActive) return;
      this.sessionActive = false;
      this.token++;
      document.body.classList.toggle('tbcq-open', Boolean(document.querySelector('tbc-discovery-quiz dialog[open]')));
      if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }
    goBack() { if (this.history.length) { this.history.pop(); this.render(); } }
    select(option) { this.history.push(option); this.render(); }
    restart() { this.history = []; this.render(); }
    render() {
      const token = ++this.token;
      const last = this.history.at(-1);
      const isResults = Boolean(last?.products);
      const depth = this.history.length;
      this.back.hidden = !depth;
      this.body.replaceChildren();
      this.body.removeAttribute('aria-busy');
      this.status.textContent = '';
      this.status.classList.remove('tbcq__status--ready');
      const trail = this.querySelector('[data-quiz-trail]');
      trail.textContent = this.history.map(item => item.label).join(' › ');
      trail.hidden = !depth;
      const stage = isResults ? 2 : depth ? 1 : 0;
      this.querySelectorAll('[data-quiz-step]').forEach((step, index) => {
        if (index === stage) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
        step.classList.toggle('is-complete', index < stage);
      });
      this.dialog.classList.toggle('tbcq--results', isResults);
      if (isResults) {
        this.heading.textContent = 'Votre sélection';
        this.intro.hidden = true;
        this.renderResults(last.products, token);
      } else {
        const question = last?.next || {
          title: 'Pour quelle occasion cherchez-vous un modèle ?',
          intro: 'Un cadeau original, une fête à préparer, un souvenir inoubliable… Qu’avez-vous en tête ?',
          options: window.TBCQuizData.events,
          layout: 'events'
        };
        this.heading.textContent = question.title.replace(/ \?/g, '\u00a0?');
        this.intro.textContent = question.intro || '';
        this.intro.hidden = !question.intro;
        const grid = element('div', `tbcq__options tbcq__options--${question.layout || 'choices'}`);
        question.options.forEach(option => {
          const button = element('button', 'tbcq__option');
          button.type = 'button';
          button.append(element('span', 'tbcq__option-title', option.label));
          const arrow = element('span', 'tbcq__option-arrow', '→');
          arrow.setAttribute('aria-hidden', 'true');
          button.append(arrow);
          button.addEventListener('click', () => this.select(option));
          grid.append(button);
        });
        this.body.append(grid);
      }
      this.querySelector('.tbcq__scroll').scrollTo(0, 0);
      this.querySelector('.tbcq__shell').scrollTo(0, 0);
      this.heading.focus({ preventScroll: true });
    }
    resultActions() {
      const actions = element('div', 'tbcq__result-actions');
      const restart = element('button', 'tbcq__text-button', 'Recommencer');
      restart.type = 'button';
      restart.addEventListener('click', () => this.restart());
      actions.append(restart);
      return actions;
    }
    async renderResults(recommendations, token) {
      this.body.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Votre sélection arrive…';
      const unique = recommendations.filter((item, index, items) => items.findIndex(candidate => candidate.handle === item.handle) === index).slice(0, 3);
      const products = await Promise.all(unique.map(async recommendation => {
        try { const data = await loadProduct(recommendation.handle); return data.available ? { ...recommendation, data } : null; }
        catch { return null; }
      }));
      if (token !== this.token || !this.dialog.open) return;
      this.body.removeAttribute('aria-busy');
      const found = products.filter(Boolean);
      if (found.length) {
        const grid = element('div', 'tbcq__results');
        grid.dataset.count = found.length;
        found.forEach(({ data, why, kind }, index) => {
          const card = element('article', `tbcq__result${kind === 'pack' ? ' tbcq__result--pack' : ''}`);
          const imageLink = element('a', 'tbcq__result-media');
          imageLink.href = previewUrl(data.url);
          imageLink.setAttribute('aria-label', data.title);
          const image = photo(data);
          if (image) imageLink.append(image);
          card.append(imageLink);
          const label = kind === 'pack' ? 'La formule en pack' : kind === 'complement' ? 'Pour compléter' : index === 0 ? 'Pour vous' : 'Une autre idée';
          card.append(element('p', 'tbcq__result-label', label));
          card.append(element('h3', '', data.title.split('|')[0].trim()));
          card.append(element('p', 'tbcq__why', why));
          const amount = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(data.price / 100);
          card.append(element('p', 'tbcq__price', `${data.price_varies ? 'À partir de ' : ''}${amount}`));
          const link = element('a', 'tbcq__product-link', kind === 'pack' ? 'Découvrir le pack' : 'Découvrir le modèle');
          link.href = previewUrl(data.url);
          card.append(link);
          grid.append(card);
        });
        this.body.append(grid);
        this.status.textContent = `${found.length} modèle${found.length > 1 ? 's' : ''} dans votre sélection.`;
        if (found.length < unique.length) this.status.textContent += ' Certains modèles ne sont pas disponibles pour le moment.';
        else this.status.classList.add('tbcq__status--ready');
      } else {
        this.status.textContent = 'Votre sélection ne peut pas s’afficher pour le moment. Vous pouvez réessayer ou modifier vos réponses.';
        const retry = element('button', 'tbcq__text-button', 'Réessayer');
        retry.type = 'button';
        retry.addEventListener('click', () => this.render());
        const collections = element('a', 'tbcq__text-button', 'Voir les collections');
        collections.href = previewUrl(`${window.Shopify?.routes?.root || '/'}collections`);
        const actions = element('div', 'tbcq__result-actions');
        actions.append(retry, collections);
        this.body.append(actions);
      }
      this.body.append(this.resultActions());
    }
  }
  customElements.define('tbc-discovery-quiz', DiscoveryQuiz);
})();
